import type { ApiFlow } from '../types'

export const m2mClientCredentialsFlow: ApiFlow = {
  id: 'm2m.client-credentials',
  appTypes: ['m2m'],
  title: 'Client credentials',
  summary:
    'Exchange client_id + client_secret for an access token, then call APIs with Authorization: Bearer.',
  steps: [
    {
      id: 'token',
      title: 'Request access token',
      when: 'Service needs an access token (cron, worker, CLI)',
      method: 'POST',
      path: '/oauth2/token',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Basic base64({{CLIENT_ID}}:<client-secret>)',
      },
      requestBody: {
        grant_type: 'client_credentials',
        scope: '{{SCOPES}}',
      },
      responseVariants: [
        {
          label: 'success',
          status: 200,
          body: {
            access_token: 'eyJ...',
            token_type: 'bearer',
            expires_in: 3600,
          },
          nextStepId: 'use',
        },
        {
          label: 'invalid client',
          status: 401,
          body: { error: 'invalid_client' },
        },
      ],
    },
    {
      id: 'use',
      title: 'Call a protected API',
      when: 'Token received',
      method: 'GET',
      path: '/api/v1/users',
      headers: { Authorization: 'Bearer <access_token>' },
      responseVariants: [
        {
          label: 'success',
          status: 200,
          body: { data: { items: [], total: 0 } },
        },
      ],
    },
  ],
}
